export const NOTE_PENDING_CHANGES_KEY = 'underwritingManualNotes';

export const NOTE_FIELD_LABEL = 'Underwriting Notes';
